import React, { useState, useEffect } from "react";
import Collapsible from "react-collapsible";
import styles from "./DoubleSentenceHighlighted.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUndoAlt } from "@fortawesome/free-solid-svg-icons";
import LessonInstruction from "../../containers/instruction/LessonInstruction";

const DoubleSentenceHL = ({ data, audioUrl, contentIndex }) => {
  const [open, setOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [contentIndex]);

  const getHilighted = (text) => {
    let splitText = text.split("[");
    let textObj = [];
    for (let i = 0; i < splitText.length; i++) {
      if (splitText[i].includes("]")) {
        let boldText = splitText[i].split("]");
        textObj.push({ word: boldText[0].replace("]", ""), highLight: true });
        textObj.push({ word: boldText[1], highLight: false });
      } else {
        textObj.push({ word: splitText[i], highLight: false });
      }
    }
    return textObj;
  };

  return (
    <div className="default-card container new-bg-color">
      {data.type === "instruction" ? (
        <LessonInstruction
          instructionText={data.instruction}
          audioUrl={audioUrl}
        />
      ) : (
        <div style={{ width: "100%" }}>
          <h2>
            <Collapsible
              triggerTagName="div"
              className="collapse-opened"
              contentOuterClassName={styles.customContentOuter}
              contentInnerClassName={styles.customContentInner}
              triggerClassName={styles.customTrigger}
              triggerOpenedClassName={styles.customTriggerOpened}
              trigger={
                <>
                  {getHilighted(data.en).map((item, index) => (
                    <span
                      key={index}
                      style={{
                        color: item.highLight ? "rgb(47, 157, 201)" : "black",
                      }}
                    >
                      {item.word}
                    </span>
                  ))}
                </>
              }
              open={open}
              onClosing={() => setIsClosing(true)}
              onOpening={() => setIsClosing(false)}
            >
              {!isClosing ? data.pt : null}
            </Collapsible>
          </h2>
          <div className={styles.containerButton}>
            <div
              className={styles.triggerButton}
              onClick={() => setOpen((prevState) => !prevState)}
            >
              <div className={styles.triggerIcon}>
                <FontAwesomeIcon icon={faUndoAlt} />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DoubleSentenceHL;
